<template>
	<v-card class="elevation-0 partners-page partners-page-container page mb-10">
		<div class="d-flex">
			<v-skeleton-loader
				v-if="isLoadingSpeakers"
				v-bind="attrs"
				max-width="555"
				width="100%"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">
				<div class="events-page__wrap mb-5">
					<FilterChipButtons
						:isButtonActive="isButtonActive"
						:chipsList="chipsList"
						:clearFilter="clearFilter"
						@handleChipClick="handleChipClick"
					/>

					<div v-if="filterModalIsVisible">
						<FilterModal
							:filterModalIsVisible="filterModalIsVisible"
							:currentModalFilter="currentModalFilter"
							:currentModalLabel="currentModalLabel"
							:selectedChips="selectedChips"
							:filters="filters"
							:dateError="date.error"
							:dateOption="date.option"
							:dateRange="date.selectedRange"
							@closeModal="closeModal"
							@applySelection="applySelection"
							@setItem="setItem"
						/>
					</div>
				</div>
				<div v-for="speaker in speakers" :key="speaker.speaker_id">
					<EventSpeakerCard :speaker="speaker" />
				</div>
				<div
					class="d-flex my-9 justify-center home-page__pagination"
					v-if="!isLoadingSpeakers"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.sessionSpeakersPageCount"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SpeakerCard from '@/components/Event/SpeakerCard'
import Filter from '@/mixins/Filter'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import Pagination from '@/components/Pagination.vue'
import EventSpeakerCard from '@/components/Event/EventSpeakerCard.vue'

export default {
	name: 'SpeakersPage',

	components: {
		EventSpeakerCard,
		Pagination,
		FilterModal,
		FilterChipButtons,
		SpeakerCard,
	},
	mixins: [Filter],

	props: {
		name: {
			type: String,
			default: 'Speakers',
		},
	},
	mounted() {
		this.setPageTitle(this.name)
	},
	beforeDestroy() {
		this.setPageTitle('')
	},

	methods: {
		...mapActions('event', ['getAllSessionsSpeaker']),
		...mapActions('app', ['setPageTitle']),
	},

	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getAllSessionsSpeaker(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('event', [
			'sessionSpeakers',
			'isLoadingSpeakers',
			'sessionSpeakersError',
			'sessionSpeakersPageCount',
		]),

		speakers() {
			return this.sessionSpeakers
				.flatMap((group) => group.speakersList || [])
				.filter((item) => item.block_name === 'speakerInfo')
				.map((item) => item.block_data)
		},
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
		}
	},
}
</script>

<style lang="scss">
.partners-page {
	background: #f1f1f1 !important;
}
</style>
